import React from 'react';

import BaseComponent from 'src/components/BaseComponent';

import { lang, permissions, remCss } from 'src/helpers';

const { PAGES } = permissions;

class AiAnalyse extends BaseComponent {
  componentDidMount() {
    this.props.model.baseSubscribe(this.subscription);
    this.props.model.resetAddAnalyse();
    this.interpret();
  }

  componentWillUnmount() {
    this.props.model.unsubscribe(this.subscription);
  }

  interpret = () => {
    const { analyseId, hide } = this.props;
    console.log('start interpreting', analyseId);
    this.props.model.aiInterpret({
      id: analyseId,
      cb: (error, data, success) => {
        if (success) hide();
        // redirect to messages/lifeapp_robot
        setTimeout(() => {
          this.navigate(PAGES.MESSAGES_PAGE.path + '/lifeapp_robot');
        }, 100);
      }
    });
  };

  render() {
    const { closeBtn } = this.props;
    return (
      <div className='mc-popup-contain' style={{ width: remCss(600) }}>
        <div className='mc-modal-header'>
          <div className='mc-popup-title'>{lang.t('AI analysis interpretation')}</div>
          {closeBtn}
        </div>

        <div
          style={{
            height: remCss(100),
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <div className='dot-falling'></div>
        </div>
        {/*<div className='mc-modal-footer mc-flex'>*/}
        {/*    <div className={'mc-grow'}/>*/}
        {/*    <MCButton*/}
        {/*        medium*/}
        {/*        primary*/}
        {/*        radius*/}
        {/*        dark*/}
        {/*        disabled={loading}*/}
        {/*        type={'submit'}*/}
        {/*        onClick={this.interpret}*/}
        {/*        label={loading ? lang.t('Interpreting...') + '...' : lang.t('Read more')}*/}
        {/*    />*/}
        {/*</div>*/}
      </div>
    );
  }
}

export default AiAnalyse;
